import { NotificationProps } from 'application/notification'
import { Toast } from 'components/ui'
import { ToastContainer } from 'components/ui/toast/toast'
import { createContext, useState, useContext } from 'react'

type NotificationID = NotificationProps['id']

interface NotificationContextProps {
  notify: (notification: NotificationProps) => void
}

const notificationCount = 0

const NotificationContext = createContext<NotificationContextProps>({
  notify: () => {},
})

export function ToastProvider({ children }: { children: any }) {
  const [notifications, setNotifications] = useState<NotificationProps[]>([])

  function removeNotification(id: NotificationID) {
    setNotifications([...notifications.filter((t) => t.id !== id)])
  }

  function notify(notification: NotificationProps) {
    const id = notification?.id || notificationCount + 1
    const delay = notification?.delay || 3000
    setNotifications([...notifications, { ...notification, id }])

    setTimeout(() => removeNotification(id), delay)
  }

  const onDismiss = (id: NotificationID) => () => removeNotification(id)

  return (
    <NotificationContext.Provider value={{ notify }}>
      {children}
      <ToastContainer>
        {notifications.map((notification) => (
          <Toast key={`toast-${notification.id}`} toast={notification} onDismiss={onDismiss(notification.id)} />
        ))}
      </ToastContainer>
    </NotificationContext.Provider>
  )
}

export const useNotification = () => useContext(NotificationContext)
